import AdvertorialAdProvider from '../provider';
import { createNewGuid, generateRandom, getViewId } from '../guidGenerator';
import * as adSpotUtil from './adSpotUtil';
import { createContainer } from '../utils/domUtil';
import { convertKeyToLowerCase, omitObjectKey, uniqueConcat } from '../utils/convertObject';
import { convertArrayToString, getInitialSize } from '../utils/transformer';
var defaultOptions = {
  config: {},
  params: {},
  sasOverrides: {}
};

function AdvertorialAdSpot() {
  var _this$config$isPrebid, _this$config$allowSan;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var createGuid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createNewGuid;
  var getViewIdFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getViewId;
  var generateRandomFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : generateRandom;
  this.guid = createGuid();
  this.viewId = getViewIdFn();
  this.random = generateRandomFn();
  this.config = options.config || {};
  this.params = options.params || {};
  this.tracking = options.tracking;
  this.cacheKey = options.cacheKey;
  this.sasOverrides = options.sasOverrides || {};
  this.appName = options.appName;
  this.isPrebid = (_this$config$isPrebid = this.config.isPrebid) !== null && _this$config$isPrebid !== void 0 ? _this$config$isPrebid : false;
  this.allowSandboxTopNavByUserActivation = (_this$config$allowSan = this.config.allowSandboxTopNavByUserActivation) !== null && _this$config$allowSan !== void 0 ? _this$config$allowSan : false;

  if (this.config['auto-hide'] !== undefined) {
    if (this.config.autoHide === undefined) {
      this.config.autoHide = this.config['auto-hide'];
    }

    console.warn('Advertorial', "options.config['auto-hide'] is deprecated, use options.config.autoHide instead.");
  }

  if (!this.config.type) {
    this.config.type = 'native';
  } else if (this.config.type !== 'native' && this.config.type !== 'lazyjs') {
    console.warn('Advertorial', "".concat(this.config.type, " is not supported!"));
  }

  if (options.container) {
    this.element = createContainer(options.config.classes);
    options.container.appendChild(this.element);
  }

  if (this.config.sz) {
    this.config.sz = convertArrayToString(this.config.sz);
  }

  this.loadCompleteCallback = options.loadCompleteCallback;
  this.resizeCompleteCallback = options.resizeCompleteCallback;
  this.nativeRenderCallback = options.nativeRenderCallback;
  this.leadClickCallback = options.leadClickCallback;
  this.nativeBeforeRenderCallback = options.nativeBeforeRenderCallback;
  this.nativeTimeout = options.nativeTimeout;
  this.logError = options.logError;

  if (this.config.site) {
    this.config.abbreviatedSite = this.config.site.split('.')[0];
  }

  if (this.element && this.element.className) {
    this.unhide();
  }

  this.convertParamsToLowerCase();
  this.previousWindowWidth = document.documentElement.clientWidth;
  this.adHidden = false;
}

AdvertorialAdSpot.prototype.convertParamsToLowerCase = function convertParamsToLowerCase() {
  this.params = convertKeyToLowerCase(this.params);
};

AdvertorialAdSpot.prototype.unhide = function unhide() {
  this.element.className = this.element.className.replace(/ rui-ad-hidden/, '');
};

AdvertorialAdSpot.prototype.hideIfRequired = function hideIfRequired() {
  if (this.config.autoHide && this.emptyAd) {
    this.element.className = "".concat(this.element.className, " rui-ad-hidden");
    this.adHidden = true;
  }
};

AdvertorialAdSpot.prototype.updateEmptyAdFlag = function updateEmptyAdFlag() {
  this.emptyAd = adSpotUtil.checkIfEmptyAd(this.nativeType, this.nativeContent);
};

AdvertorialAdSpot.prototype.getLink = function getLink(bidResult) {
  return AdvertorialAdProvider.getCurrent().generateAdLink(this, bidResult);
};

AdvertorialAdSpot.prototype.getUniqueParams = function getUniqueParams() {
  return {
    pos: this.params.pos
  };
};

AdvertorialAdSpot.prototype.getPageParams = function getPageParams() {
  return omitObjectKey(this.params, 'pos');
};

AdvertorialAdSpot.prototype.isAdLoaded = function isAdLoaded() {
  return !(this.emptyAd || this.adHidden);
};

AdvertorialAdSpot.prototype.isMultiSize = function (sizes) {
  return sizes.indexOf(',') > -1;
};

AdvertorialAdSpot.prototype.getInitialSize = function (availableSizes) {
  return availableSizes.split(',')[0];
};

AdvertorialAdSpot.prototype.getAvailableSizes = function getAvailableSizes() {
  var sizes = this.config.sz.split(',');
  var renderSizes = this.config.renderSize ? this.config.renderSize.split(',') : [];
  var availableSizes = uniqueConcat(sizes, renderSizes);

  if (!this.isMultiSize(availableSizes)) {
    return availableSizes;
  }

  var initialSize = getInitialSize(availableSizes);
  return "".concat(initialSize, ",").concat(availableSizes);
};

AdvertorialAdSpot.prototype.reset = function reset() {
  this.unhide();
  this.element.innerHTML = '';
};

AdvertorialAdSpot.prototype.cleanup = function cleanup() {
  this.updateEmptyAdFlag();
  this.hideIfRequired();
};

AdvertorialAdSpot.prototype.insertAdvertisementHeading = function showHeadingIfRequired() {
  if (this.config.showHeading) {
    adSpotUtil.appendHeading(this.element, this.config.headingAlignment);
  }
};

export default AdvertorialAdSpot;
//# sourceMappingURL=AdvertorialAdSpot.js.map